<div
  @PopoverAnimation
  #Popover
  class="cb-popover-wrapper"
  [ngClass]="
    'cb-popover-position-' + position() + ' cb-popover-align-' + alignment()
  "
  [style.left.px]="leftPosition()"
  [style.top.px]="topPosition()"
  [class.cb-arrow]="showArrow()"
>
  <div class="cb-popover-container">
    @if (template()) {
      <div class="cb-popover-content">
        <ng-container
          *ngTemplateOutlet="template(); context: context()"
        ></ng-container>
      </div>
    }

    @if (this.groupedOptions().length > 0) {
      <div class="cb-popover-grouped-options">
        @for (group of groupedOptions(); track $index) {
          <ul class="cb-popover-options">
            @for (option of group.options; track $index) {
              <ng-container
                *ngTemplateOutlet="
                  OptionTemplate;
                  context: { $implicit: option }
                "
              ></ng-container>
            }
          </ul>
        }
      </div>
    } @else if (this.options().length > 0) {
      <ul class="cb-popover-options">
        @for (option of options(); track $index) {
          <ng-container
            *ngTemplateOutlet="OptionTemplate; context: { $implicit: option }"
          ></ng-container>
        }
      </ul>
    }
  </div>
</div>

<ng-template #OptionTemplate let-option>
  @let template = optionsTemplate();

  @if (template) {
    <li
      (click)="optionClicked(option)"
      [ngClass]="'cb-popover-option-' + option.color"
      [class.cb-popover-option-disabled]="option.disabled"
    >
      <ng-container
        *ngTemplateOutlet="template; context: { $implicit: option }"
      ></ng-container>
      @if (option.selected) {
        <cb-icon
          class="cb-popover-option-selected"
          name="cb-base-outline-check"
        ></cb-icon>
      }
    </li>
  } @else {
    <li
      (click)="optionClicked(option)"
      [ngClass]="'cb-popover-option-' + option.color"
      [class.cb-popover-option-disabled]="option.disabled"
    >
      @if (option.icon) {
        <cb-icon [name]="option.icon"></cb-icon>
      }
      <p>{{ option.label | translate }}</p>
      @if (option.selected) {
        <cb-icon
          class="cb-popover-option-selected"
          name="cb-base-outline-check"
        ></cb-icon>
      }
    </li>
  }
</ng-template>
